import { render, staticRenderFns } from "./ShopCartInfoSum.vue?vue&type=template&id=0affbda2&scoped=true&"
import script from "./ShopCartInfoSum.vue?vue&type=script&lang=js&"
export * from "./ShopCartInfoSum.vue?vue&type=script&lang=js&"
import style0 from "./ShopCartInfoSum.vue?vue&type=style&index=0&id=0affbda2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affbda2",
  null
  
)

export default component.exports